import { CancellationTicketReport } from '../../../../../core/models/reports/cancellation.ticket.report.model';


export const cancellationTicketReport = {
  searchText: '',
  sort: true,
  dialogHability: true,
  filter: false,
  alterColumns: true,
  paginator: true,
  checkbox: false,
  export: true,
  exportAllData: true,
  exportFile: 'reporte_ticket_anulacion.xlsx',
  expandable: false,
  disabled: false,
  partialField: '',
  columns: [
    {
      title: 'Número de Ticket de anulación',
      name: 'ticketNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.ticketNumber
    },
    {
      title: 'Tienda de anulación',
      name: 'cancellationEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.cancellationEntity
    },
    {
      title: 'Usuario',
      name: 'username',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.username
    },
    {
      title: 'Fecha de anulación',
      name: 'cancellationDate',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.cancellationDate
    },
    {
      title: 'Fecha de venta',
      name: 'saleDate',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: true,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.saleDate
    },
    {
      title: 'Entidad de venta',
      name: 'saleEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.saleEntity
    },
    {
      title: 'Nota de venta',
      name: 'orderNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.orderNumber
    },
    {
      title: 'Despacho',
      name: 'dispatchNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.dispatchNumber
    },
    {
      title: 'Motivo de cancelación',
      name: 'reasonCancellation',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.reasonCancellation
    },
    {
      title: 'División de producto',
      name: 'productDivision',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.divisionDescription
    },
    {
      title: 'Área de producto',
      name: 'productArea',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.areaDescription
    },
    {
      title: 'Departamento de producto',
      name: 'productDepartment',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.departmentDescription
    },
    {
      title: 'Línea de producto',
      name: 'productLine',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.lineDescription
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.skuCode
    },
    {
      title: 'Cantidad comprada',
      name: 'units',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.units
    },
    {
      title: 'Cantidad anulada',
      name: 'unitsCanceled',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: CancellationTicketReport) => element.unitsCanceled
    },
    {
      title: '',
      name: 'stateDispatch',
      type: 'editableColumns',
      visible: true,
      editable: true,
      checkAll: true,
      class: 'width-none',
      value: () => ''
    }
  ]
};
